export const WAREHOUSE_BASE_PATH = '/warehouses';
export const WAREHOUSE_INTERNAL_EQUIPMENT_BASE_PATH = '/warehouses/internal-equipment';
export const WAREHOUSE_WORKING_HOURS = `${WAREHOUSE_BASE_PATH}/working-hours`;
export const generateWarehouseAlertPath = (warehouseId: string): string => `${WAREHOUSE_BASE_PATH}/${warehouseId}/alert`;
export const generateWarehouseIsControllerHealthyPath = (warehouseId: string): string =>
  `${WAREHOUSE_BASE_PATH}/${warehouseId}/availability`;
export const generateWarehouseSirenStatusPath = (warehouseId: string): string => `${WAREHOUSE_BASE_PATH}/${warehouseId}/siren`;

export const SUMMARY_BASE_PATH = '/summary';
